import React, { useEffect, useRef, useState } from "react";
import Engine from '../../classes/Engine';
import ScopeCamera from '../../classes/Camera';
import { CustomEventTypes } from "../../globals";
import useEventListener from "../reactUtils/useEventListener";

export default function FullCameraPreview(props: { 
	cameraId: string,
	onClick?: () => void,
})
{
	useEventListener(CustomEventTypes.cameraRendered, handleCameraRendered, document);

	const [scopeCamera, setScopeCamera] = useState<ScopeCamera>();

	const rootRef = useRef<HTMLDivElement>(null);
	const canvasRef = useRef<HTMLCanvasElement>(null);

	const resolution = 1080;

	useEffect(() => 
	{
		scopeCamera?.toggleUpdateCanvas(false);
		
		const camera = ScopeCamera.getSceneCameras(Engine.getInstance().getCurrentScene()).find(c => c.userData.guid === props.cameraId);
		camera?.toggleUpdateCanvas(true);
		setScopeCamera(camera);

		return () => 
		{
			scopeCamera?.toggleUpdateCanvas(false);
		}
	}, [props.cameraId]);

	function handleCameraRendered(e) 
	{
		if (e.detail.cameraId !== props.cameraId || !scopeCamera || !canvasRef?.current) return;

		const context = canvasRef.current.getContext('2d');
		if(!context) return;

		context.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
		context.drawImage(
			scopeCamera.canvas, // image to draw
			0, 0, scopeCamera.canvas.width, scopeCamera.canvas.height, // source rect
			0, 0, canvasRef.current.width, canvasRef.current.height // destination rect
		);
		context.globalCompositeOperation = "source-over";
		context.lineWidth = 5;
		context.strokeStyle = "#000000";
		context.strokeRect(0, 0, canvasRef.current.width, canvasRef.current.height);
	}

	return (
		<div ref={rootRef}
			data-name={"camera-preview-root"}
			className={"fullScreen"}
		>
			<canvas ref={canvasRef} 
				onClick={props.onClick}
				className={"fullScreen"}
				height={resolution}
				width={resolution * (scopeCamera?.getCameraAspect() ?? 1)}
			/>
		</div>
	);
}